import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from "vue";
import { useI18n } from "vue-i18n";

interface Props {
  lang: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    lang: null
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
  lang: string;
};

const { locale } = useI18n();


const { lang } = toRefs(props);

locale.value = lang.value;

const __returned__ = { locale, props, lang, toRefs, get useI18n() { return useI18n } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})